var map = {
	"./categorias/categorias.module": [
		"./src/app/menu/categorias/categorias.module.ts",
		"default~categorias-categorias-module~envio-documento-envio-documento-module~menu-menu-module~process~43efacb9",
		"common",
		"categorias-categorias-module"
	],
	"./envio-documento/envio-documento.module": [
		"./src/app/menu/envio-documento/envio-documento.module.ts",
		"default~categorias-categorias-module~envio-documento-envio-documento-module~menu-menu-module~process~43efacb9",
		"default~envio-documento-envio-documento-module~processos-processos-module",
		"common"
	],
	"./menu/menu.module": [
		"./src/app/menu/menu.module.ts",
		"default~categorias-categorias-module~envio-documento-envio-documento-module~menu-menu-module~process~43efacb9",
		"common",
		"menu-menu-module"
	],
	"./processos/processos.module": [
		"./src/app/menu/processos/processos.module.ts",
		"default~categorias-categorias-module~envio-documento-envio-documento-module~menu-menu-module~process~43efacb9",
		"default~envio-documento-envio-documento-module~processos-processos-module",
		"common",
		"processos-processos-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;